import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';
import ProgrammingServices from './components/ProgrammingServices';
import SupportedPlatformsSection from './components/SupportedPlatformsSection';



export default function ProgrammingPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <ProgrammingServices />
        <SupportedPlatformsSection />
        <ProcessSection serviceType="takeoff" /> {/* Reusing takeoff process as it's generic enough or matches the workflow */}
        <CTASection serviceType="takeoff" />
      </main>
      <Footer />
    </div>
  );
}
